export default __webpack_public_path__ + "static/media/1.7cf9a9d7.png";